import React from "react";
import {Typography} from "@material-ui/core";
import StyleWelcomeView from "./styles/StyleWelcomeView";
import i18n from 'i18next';

const TestInfoDetail = (props) => {
    const {testInfo} = props;
    const classes = StyleWelcomeView();
    let isTest = testInfo && testInfo.hasOwnProperty('testCode');
    let isFinalTest = testInfo && testInfo.hasOwnProperty('lessonTypeId') && testInfo.lessonTypeId === 1;

    let testDetail =
        <React.Fragment>
            <Typography variant="h5" align="center" className={classes.testName}>
                <b>{testInfo.name}</b>
            </Typography>

            <Typography variant="h6" align="center" className={classes.subTitle}>
                <b>{i18n.t('time')}: {testInfo.duration} {i18n.t('minute')} - {i18n.t('question_number')}: {testInfo.numberOfQuestions}</b>
            </Typography>
            <Typography variant="h6" align="center" className={classes.subTitle}>
                <b>{i18n.t('number_of')}
                    {testInfo.testTypeId === 1 ? ` ${i18n.t('test')}` :
                        testInfo.testTypeId === 2 ? ` ${i18n.t('practice')}` :
                            testInfo.testTypeId === 3 ? ` ${i18n.t('exam')}` : ""
                    }
                    : {testInfo.tryTimes}/{testInfo.numberOfRetries}</b>
            </Typography>
        </React.Fragment>;


    let normalLesson =
        <React.Fragment>
            <Typography variant="h5" align="center" className={classes.testName}>
                <b>{testInfo.name}</b>
            </Typography>

            <Typography variant="h6" align="center" className={classes.subTitle}>
                <b>{testInfo.duration ? `${i18n.t('time')}: ` + testInfo.duration + ` ${i18n.t('minute')} - ` : ""}{i18n.t('question_number_learning')}: {testInfo.numberOfQuestions}</b>
            </Typography>
        </React.Fragment>;

    let finalLessonTest =
        <React.Fragment>
            <Typography variant="h6" align="center" className={classes.testName}>
                <b>{i18n.t('welcome_final_test')}</b>
            </Typography>
            {
                testInfo.hasOwnProperty("numberOfRetries") && testInfo.numberOfRetries > 0 ?
                    <React.Fragment>
                        <Typography variant="h6" align="center" className={classes.subTitle}>
                            <b>{i18n.t('max_try_time')}: <span style={{color: 'red'}}>{testInfo.numberOfRetries}</span> {i18n.t('times')}</b>
                        </Typography>
                        <Typography variant="h6" align="center" className={classes.subTitle}>
                            <b>{i18n.t('number_try_time')}: <span
                                style={{color: 'red'}}>{testInfo.tryTimes}</span> lần</b>
                        </Typography>
                    </React.Fragment>
                    :
                    <Typography variant="h6" align="center" className={classes.subTitle}>
                        <b>{i18n.t('unlimited')}</b>
                    </Typography>
            }
        </React.Fragment>;

    if (isTest)
        return testDetail;
    if (isFinalTest)
        return finalLessonTest;
    return normalLesson;
};

export default TestInfoDetail;

